var _path, _path2, _path3, _path4, _path5, _path6, _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ComorosCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fdd835",
    d: "M6.697,14h34.605C37.843,8.028,31.398,4,24,4S10.157,8.028,6.697,14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M44,24c0-3.647-0.992-7.056-2.697-10H6.697C4.992,16.944,4,20.353,4,24H44z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M41.302,34C43.008,31.056,44,27.647,44,24H4c0,3.647,0.992,7.056,2.698,10H41.302z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#283593",
    d: "M24,44c7.398,0,13.843-4.028,17.302-10H6.698C10.157,39.972,16.602,44,24,44z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#43a047",
    d: "M11.565,8.353C6.96,12.017,4,17.658,4,24s2.96,11.983,7.565,15.647L36.6,24L11.565,8.353z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.308,24.187c0-3.983,2.976-7.278,6.87-7.895C17.496,16.107,16.782,16,16.042,16 c-4.521,0-8.187,3.665-8.187,8.187s3.665,8.187,8.187,8.187c0.741,0,1.455-0.107,2.137-0.291 C14.285,31.464,11.308,28.17,11.308,24.187z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "18.314,17.161 18.717,18.236 19.864,18.287 18.966,19.002 19.272,20.108 18.314,19.476 17.357,20.108 17.662,19.002 16.765,18.287 17.912,18.236"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "18.314,20.793 18.717,21.867 19.864,21.919 18.966,22.634 19.272,23.74 18.314,23.108 17.357,23.74 17.662,22.634 16.765,21.919 17.912,21.867"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "18.314,24.454 18.717,25.529 19.864,25.58 18.966,26.295 19.272,27.402 18.314,26.769 17.357,27.402 17.662,26.295 16.765,25.58 17.912,25.529"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "18.314,28.086 18.717,29.161 19.864,29.212 18.966,29.927 19.272,31.034 18.314,30.401 17.357,31.034 17.662,29.927 16.765,29.212 17.912,29.161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ComorosCircular);
export default __webpack_public_path__ + "static/media/icons8-comoros-circular.360a72fa0aadd04a3a831638d320b9d5.svg";
export { ForwardRef as ReactComponent };